export default __webpack_public_path__ + "b5ae26d1d02a3a2a6bd07830c7e12259.png";